import { render, staticRenderFns } from "./FormElementMultiple.vue?vue&type=template&id=38a2729a&scoped=true&"
import script from "./FormElementMultiple.vue?vue&type=script&lang=js&"
export * from "./FormElementMultiple.vue?vue&type=script&lang=js&"
import style0 from "./FormElementMultiple.vue?vue&type=style&index=0&id=38a2729a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2729a",
  null
  
)

export default component.exports